import MyLocationIcon from '@material-ui/icons/MyLocation';
import PropTypes from 'prop-types';
import React from 'react';

const ShapePoint = ({ fillColor = 'black', fontSize = undefined, strokeColor = 'white' }) => (
    <MyLocationIcon stroke={strokeColor} style={{ color: fillColor, fontSize }} />
);

ShapePoint.propTypes = {
    fillColor: PropTypes.string,
    fontSize: PropTypes.string,
    strokeColor: PropTypes.string,
};

export default ShapePoint;
